var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvanceIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 42,
    viewBox: "0 0 36 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_75_6855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 10.659C27 12.837 24.885 14.844 21.705 17.985C20.7163 18.9561 19.3858 19.5001 18 19.5001C16.6142 19.5001 15.2837 18.9561 14.295 17.985C11.115 14.8425 9 12.8355 9 10.6575C9 8.4795 9.531 8.043 14.412 3.2175C14.883 2.7495 15.69 3.0795 15.69 3.738V8.706C15.69 9.966 16.7235 10.9905 18 10.9905C19.275 10.9905 20.31 9.969 20.31 8.7075V3.741C20.31 3.081 21.12 2.7525 21.588 3.2205C26.469 8.0445 27 8.481 27 10.659Z",
    stroke: "url(#paint0_linear_75_6855)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18V28.7475C22.5 31.0965 20.4855 33 18 33C15.5145 33 13.5 31.095 13.5 28.7475V18M18.009 28.5L18 28.509",
    stroke: "url(#paint1_linear_75_6855)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_75_6855",
    x: 4.25,
    y: 2.24828,
    width: 27.5,
    height: 39.5017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_75_6855"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_75_6855",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_6855",
    x1: 23.6163,
    y1: 68.4315,
    x2: 4.56618,
    y2: 67.1142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7928CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_6855",
    x1: 20.8081,
    y1: 77.4771,
    x2: 11.2514,
    y2: 77.1136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7928CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanceIcon02);
export default __webpack_public_path__ + "static/media/advanceIcon02.3e1502595c5380a77e37da8c709a6184.svg";
export { ForwardRef as ReactComponent };